import axiosInstance from '../helpers/axios';

export type TOpsTrainerClass = {
  locationAddress?: string | null;
  onsiteContact?: string | null;
  reasonForSession?: string | null;
  audienceInformation?: string | null;
  recordingDetails?: string | null;
  accountId?: string | null;
  id: string;
  name: string | null;
  start: string | null;
  end: string | null;
  classType: string | null;
  status: string | null;
  location: string | null;
  accountName: string | null;
  registered: number;
  zoomRoom: {
    name: string | null;
    joinUrl: string | null;
    locationAddress?: string | null;
    onsiteContact?: string | null;
    reasonForSession?: string | null;
    audienceInformation?: string | null;
    recordingDetails?: string | null;
    accountId?: string | null;
  } | null;
  notes: {
    program: {
      programId: string;
      programName: string | null;
      info: string | null;
      visible: boolean;
    } | null;
    trainer: string | null;
    payment: string | null;
  };
  links: {
    learnerLink: string | null;
    privateClassLink: string | null;
    icalLink: string | null;
    studentSurvey: string | null;
    instructorSurvey: string | null;
    courseOutline: string | null;
  };
  series: { id: string; index: number | null; count: number | null } | null;
  /** Delivery details the instructor needs for the run */
  delivery: {
    prepCallStatus: string | null;
    materials: { status: string | null; trackingNote: string | null };
    travelStatus: string | null;
    travelNotes: string | null;
    customisationHours: number | null;
    customisationNotes: string | null;
  };
};

export type TOpsTrainerSchedule = {
  instructor: string;
  items: TOpsTrainerClass[];
};

export const getOpsTrainerSchedule = async (
  instructor: string,
  opts: {
    when?: 'upcoming' | 'past' | 'all';
    from?: string;
    to?: string;
    accountId?: string;
    q?: string;
  } = {},
) => {
  const response = await axiosInstance.get<TOpsTrainerSchedule>(
    'ops/trainer/schedule',
    { params: { instructor, ...opts } },
  );
  return response.data;
};
